import UpdateImportCnfBill from "./Update";

export default function ViewImportCnfBill(props) {
  return <UpdateImportCnfBill {...props} viewMode />;
}
